// Catalog of togglable RichText formatting features. Each key maps to one
// or more tiptap/element-tiptap extensions in RichTextEditor.vue's
// buildExtensions(). Add an entry here + a branch in buildExtensions() to
// introduce a new togglable feature; both the schema-field allowlist UI
// (schema/fields/RichText.vue) and the editor itself read from this list,
// so there's one place to keep them in sync.
export const RICH_TEXT_FEATURES = [
  { key: "bold", label: "Bold" },
  { key: "italic", label: "Italic" },
  { key: "underline", label: "Underline" },
  { key: "strike", label: "Strikethrough" },
  { key: "code", label: "Inline Code" },
  { key: "font_type", label: "Font Family" },
  { key: "text_color", label: "Text Color" },
  { key: "text_highlight", label: "Highlight" },
  { key: "typography", label: "Typography Classes (Body / Statement / Headings)" },
  { key: "lists", label: "Bullet & Numbered Lists" },
  { key: "blockquote", label: "Blockquote" },
  { key: "text_align", label: "Text Align" },
  { key: "line_height", label: "Line Height" },
  { key: "indent", label: "Indent" },
  { key: "horizontal_rule", label: "Horizontal Rule" },
  { key: "link", label: "Links" },
  { key: "image", label: "Images" },
  { key: "iframe", label: "Video Embeds" },
  { key: "table", label: "Tables" },
];

export const RICH_TEXT_FEATURE_KEYS = RICH_TEXT_FEATURES.map((f) => f.key);

// Feature set for the pre-existing `simple` prop on RichTextEditor.vue
// (e.g. `<RichTextEditor simple />` in _form.venue-events.page.vue).
export const SIMPLE_FEATURE_KEYS = [
  "bold",
  "underline",
  "italic",
  "typography",
  "lists",
  "text_align",
  "indent",
  "blockquote",
  "link",
];

// Resolves the enabled feature keys for a RichTextEditor instance -
// `features` wins if given, otherwise `simple` maps to its fixed subset,
// otherwise everything is enabled (the original default/"full" toolbar).
export function resolveFeatureKeys({ features, simple } = {}) {
  if (Array.isArray(features)) return features;
  if (simple) return SIMPLE_FEATURE_KEYS;
  return RICH_TEXT_FEATURE_KEYS;
}
